const coda = {
  C: "#004aad",
  O: "#779cd3",
  D: "#fc876d",
  A: "#004aad",
};

export default coda;
